module.exports = __webpack_public_path__ + "static/media/DeadBatteryMarker.d4ea55ec.svg";